export class Rotulo {
  constructor ({
    apresentacao,
    modo_uso,
    consumo,
    indicacao,
    restricoes,
    validade,
  } = {}) {
    this.apresentacao = apresentacao
    this.modo_uso = modo_uso
    this.consumo = consumo
    this.indicacao = indicacao
    this.restricoes = restricoes
    this.validade = validade
  }
}

export function createRotulo (data) {
  return Object.freeze(new Rotulo(data))
}
